import React, { useEffect, useState } from "react";
import LoadingScreen from "../../Shared/LoadingScreen";
import OpenSnackbar from "../../Shared/OpenSnackbar";
import Table from "../../Shared/Table";
import { useErrorHandler } from "react-error-boundary";
import axios from "axios";
import { PrimaryButton } from "src/Shared/Buttons";
import { useHistory } from "react-router-dom";
import ModalComp from "src/Shared/ModalComp";

const PosDataComp = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [loadMore, setLoadMore] = useState(false);
  const [posData, setPosData] = useState([]);
  const [openModal, setopenModal] = useState(false);
  const [details, setDetails] = useState({})
  const history = useHistory();
  const ErrorHandler = useErrorHandler();
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    type: "",
  });
  const handleClose = () => {
    setopenModal(!openModal);
  };
  const handleSnackbarOpen = (message, type) => {
    let obj = {
      message,
      type,
    };
    setSnackbarDetails(obj);
    setSnackbarOpen(true);
  };

  const getPosData = async () => {
    setIsLoading(true);
    try {
      let { data } = await axios.get(
        process.env.REACT_APP_API_URL + `restaurant/license-api-keys-data`,
        {
          limit: 70,
          lastEvaluatedkey: null,
        }
      );
      setIsLoading(false);
      setPosData([...data?.api_key_data]);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPosData();
  }, []);

  const getTime = (time) => {
    let key = parseInt(time);
    return (
      new Date(key).toDateString() +
      " " +
      new Date(key).getHours() +
      ":" +
      new Date(key).getMinutes() +
      ":" +
      new Date(key).getSeconds()
    );
  };

  const handleDetails =(item)=>{
    setopenModal(true)
    console.log("this item",item);
    setDetails(item)
  }

  const formatData = (data) => {
    let formattedData = data.map((item, index) => ({
      key: item.key || "—",
      device_id: item.device_id || "—",
      created_at: item.timestamp ? getTime(item.timestamp) : "—",
      rest_name: item.restaurant_name || "-",
      details: (
        <PrimaryButton
          size="small"
          style={{ width: "100px" }}
          handleClick={()=>handleDetails(item)}
        >
          DETAILS
        </PrimaryButton>
      ),
    }));
    return formattedData;
  };

  const columns = [
    {
      name: "key",
      label: "Key",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "rest_name",
      label: "Linked Restaurant",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "device_id",
      label: "Device Id",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "created_at",
      label: "Created At",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "details",
      label: "Details",
      options: {
        sort: false,
        filter: false,
      },
    },
  ];
  const onTableChangeHandler = (action, tableState) => {
    // const { page, rowsPerPage, data } = tableState;
    // let diff = Math.abs(page * rowsPerPage - data.length);
    // if (
    //   diff <= rowsPerPage &&
    //   lastEvaluatedkey?.id?.length > 0 &&
    //   (action === "changePage" || action === "changeRowsPerPage")
    // ) {
    //   dispatch(licenseApiKeysActions(lastEvaluatedkey));
    //   return;
    // }
  };

  return (
    <>
      {isLoading ? (
        <LoadingScreen loading={isLoading} />
      ) : (
        <>
          <ModalComp
            open={openModal}
            handleClose={handleClose}
            whichModal={"pos"}
            children={details}
            top={"15%"}
            width={"60%"}
            minHeight={400}
          />
          <Table
            data={formatData(posData)}
            columns={columns}
            title="POS Data"
            onTableChange={onTableChangeHandler}
          />
          {snackbarOpen && (
            <OpenSnackbar
              message={snackbarDetails.message}
              type={snackbarDetails.type}
              open={snackbarOpen}
              setOpen={setSnackbarOpen}
              vertical="bottom"
              horizontal="center"
            />
          )}
        </>
      )}
    </>
  );
};

export default PosDataComp;
